import * as Yup from 'yup';
import { validarCPF } from './uteis';

export const cpfValidation = (requiredMessage = 'CPF é obrigatório') => {
  return Yup.string()
    .required(requiredMessage)
    .test('cpf-format', 'CPF inválido. Formato esperado: XXX.XXX.XXX-XX ou 12345678900', (value) => {
      if (!value) return false;
      const cleanedCpf = value.replace(/\D/g, '');
      return cleanedCpf.length === 11;
    })
    .test('cpf-valid', 'CPF inválido. Os dígitos verificadores não conferem. Por favor, verifique o CPF informado.', (value) => {
      if (!value) return false;
      const cleanedCpf = value.replace(/\D/g, '');
      if (cleanedCpf.length !== 11) {
        return true;
      }
      const isValid = validarCPF(value);
      if (!isValid) {
        return false;
      }
      return true;
    });
};

